import * as ActionTypes from '../constants/actionTypes';
import { vehicleService } from '../services/vehicleService';

import { toast } from 'react-toastify';


export function checkVehicleReg(regNo) {
    return dispatch => {
        dispatch(request(regNo));
        return vehicleService.checkVehicleReg(regNo)
        .then((response) => {
            let motorInfo = response.data;
            dispatch(success(motorInfo, regNo));
        })
        .catch(error => dispatch(failure(error, regNo)));
    };
    function request(regNo ) { return { type: ActionTypes.CHECK_VEHICLE_REG_REQUEST, regNo }; }
    function success(data, regNo) { return { type: ActionTypes.CHECK_VEHICLE_REG_SUCCESS, data, regNo }; }
    function failure(error, regNo) {
        toast.error("Vehicle not found. Enter details manually...", {
            autoClose: 10000,
            hideProgressBar: false
        });
        return { type: ActionTypes.CHECK_VEHICLE_REG_FAILURE, error, regNo }; 
    }
}

export function getVehiclesList() {
    return dispatch => {
        dispatch(request());
        return vehicleService.vehiclesList()
            .then((response) => {
                let list = response.data;
                console.log('response.data, ', response.data);
                dispatch(success(list));
            })
            .catch(error => dispatch(failure(error)));
    };
    function request( ) { return { type: ActionTypes.GET_VEHICLE_LIST_REQUEST }; }
    function success(data) { return { type: ActionTypes.GET_VEHICLE_LIST_SUCCESS, data }; }
    function failure(error) {return { type: ActionTypes.GET_VEHICLE_LIST_FAILURE, error }; }
}


export function addVehicle(data){
    return { type: ActionTypes.ADD_VEHICLE,  data}; 
}

















// WEBPACK FOOTER //
// ./src/actions/vehicleActions.js